import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {VerticalAlignTopOutlined} from "@ant-design/icons";
import streenTheme from "../css/theme.scss";
import {
  Row,
  ConfigProvider,
  Pagination,
  Carousel,
  Avatar,
  message,
  Tooltip,
  Button,
  Typography,
  Flex,
  Radio,
  Space,
  Drawer,
  Tag,
  Dropdown,
  Modal
} from "antd";


import { QrReader } from "react-qr-reader";

import streen_theme from "../css/theme.scss";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import "../StoryCreator.css"; // Custom styles for story creator
import { taskRegistry } from "../config/taskRegistry";

import AuthContext from "../context/authContext";
import { sanitizeTtsText, useSentenceReadAloud } from "../context/ttsService";
import app_logo from "../img/logo.png";

import Notifications from "./Notifications";
import Messages from "../components/Messages";

import CharacterImage from "../components/CharacterImage";
import { connectWebSocket, sendWord } from "../components/SocketSender";

import { fetchRecordedAudio } from "../context/recorderService";

import WordDetective from "../Modals/WordDetective";

import conn_icon from "../img/auslosen_icons/conn.svg";
import no_conn_icon from "../img/auslosen_icons/not_conn.svg";
import scan_qr_icon from "../img/auslosen_icons/scan_qr.svg";
import projector_disabled_icon from "../img/auslosen_icons/projector_disabled.svg";
import projector_enabled_icon from "../img/auslosen_icons/projector_enabled.svg";
import gallery_icon from "../img/auslosen_icons/gallery.svg";



import speech_icon from "../img/vorlesen_icons/speech.svg";
import stop_icon from "../img/vorlesen_icons/stop.svg";
import play_icon from "../img/vorlesen_icons/play.svg";
import pause_icon from "../img/vorlesen_icons/pause.svg";

import tag_delete_icon from "../img/sammeln_icons/tag_delete.svg";
import sammeln_header_menu_main_icon from "../img/sammeln_icons/sammeln_header_menu_main.svg";
import sammeln_header_menu_mini_icon from "../img/sammeln_icons/sammeln_header_menu_mini.svg";

import word_wall_icon from "../img/operationMenu_icons/entdecken.svg";



// import AddCharacter from "../Modals/AddCharacter";

// Operation modes enum
import { OPERATION_MODES } from '../config/operationModes';    

const verbose = true; // set to true to enable debug logging
const vlog = (...args) => verbose && console.log(...args);

const ReaderMode = (
  {
    storyTitle,
    storyId,
    setSelectedSentences,
    selectedSentences,
    setSelectedCharacters,
    selectedCharacters,
    storyHighlights,
    selectedOperation,
    handleSelectOperation,
    handleHighlight,
    handleWordClarification,
    handleEnrichment,
    handleAuthoring,
    handleStoryEdit,
    handleWordCloud,
    handleAudioRecording,
    onAuthoringClick,
    navToGestaltenPage,
    isEditing,
    isLexi,
    setIsLexi,
    presentationMode,
    setPresentationMode,
    currentGroupId,
    currentVisibility,
  }) => {
  const navigate = useNavigate();
  const lastTapTime = useRef(0);
  const {
    showMessageError,
    showMessageWarning,
    showMessageInfo,
    showMessageSuccess,
  } = Messages();
  const { currentUser } = useContext(AuthContext);
  // const [isSentenceModalVisible, setIsSentenceModalVisible] = useState(false);
  // #region VORLESEN
  const { startSentence, stopSentence, speakText, speaking, isSentenceSpeaking, getSentenceWordIndex } =
    useSentenceReadAloud();
  const [activeReadAloudWordId, setActiveReadAloudWordId] = useState(null);
  const [isPageTtsPlaying, setIsPageTtsPlaying] = useState(false);
  const [isPageTtsPaused, setIsPageTtsPaused] = useState(false);
  const [pageTtsQueue, setPageTtsQueue] = useState([]);
  const [pageTtsIndex, setPageTtsIndex] = useState(-1);
  const [playingRecordedAudio, setPlayingRecordedAudio] = useState(null); // Track which sentence's recorded audio is playing
  const playingRecordedAudioRef = useRef(null); // Reference to the audio element
  const [highlightedWords, setHighlightedWords] = useState([]); // Track highlighted words for drawer
  const [drawerVisible, setDrawerVisible] = useState(false); // Control drawer visibility
  const [selectedSammelnOption, setSelectedSammelnOption] = useState(null); // Track selected sammeln option
  
  const wasSpeakingRef = useRef(false);

  const stopPageReadAloud = () => {
    setIsPageTtsPlaying(false);
    setIsPageTtsPaused(false);
    setPageTtsQueue([]);
    setPageTtsIndex(-1);
  };

  useEffect(() => {
    if (isPageTtsPlaying && !isPageTtsPaused && wasSpeakingRef.current && !speaking) {
      const nextIndex = pageTtsIndex + 1;
      const nextSentence = pageTtsQueue[nextIndex];

      if (nextSentence) {
        setPageTtsIndex(nextIndex);
        startSentence(nextSentence.id, nextSentence.text);
      } else {
        stopPageReadAloud();
      }
    }

    wasSpeakingRef.current = speaking;
  }, [speaking, isPageTtsPlaying, isPageTtsPaused, pageTtsIndex, pageTtsQueue, startSentence]);

  useEffect(() => {
    if (!speaking) {
      setActiveReadAloudWordId(null);
    }
  }, [speaking]);
  //#endregion tts service


  // #region AUSLOSEN
  const [storyEnrichments, setStoryEnrichments] = useState([]); // Local state for story enrichments
  
  // Debug log when storyEnrichments changes
  useEffect(() => {
    vlog("storyEnrichments updated:", storyEnrichments);
  }, [storyEnrichments]);
  useEffect(() => {
    // Only fetch enrichments when in AUSLOSEN mode
    if (selectedOperation !== OPERATION_MODES.AUSLOSEN) {
      vlog("Skipping enrichments fetch - not in AUSLOSEN mode, current mode:", selectedOperation);
      // Clear enrichments when not in AUSLOSEN mode
      setStoryEnrichments([]);
      return;
    }
    
    // Only fetch enrichments if we have the required data
    if (!storyId || !currentUser) {
      vlog("Skipping enrichments fetch - missing storyId or currentUser");
      return;
    }
    
    vlog("Fetching enrichments for storyId:", storyId, "groupId:", currentGroupId, "userId:", currentUser.id);
    const fetchEnrichments = async () => {
      try {
        const underlineResponse = await axios
          .get(`/api/enrichments/`, {
            params: {
              storyid: storyId,
              userid: currentUser.id, // Needed to check private enrichments
              groupId: Number(currentGroupId) || 0, // Needed to check group enrichments
            },
          })
          .catch((error) => {
            console.error("Error fetching enrichments:", error);
          });

        vlog("ReaderMode enrichments response:::", underlineResponse?.data);

        
        setStoryEnrichments(underlineResponse?.data || []);
        
      } catch (err) {
        console.error("Error fetching enrichments:", err);
      }
    };
    fetchEnrichments();

  }, [selectedOperation, storyId, currentGroupId, currentUser]);

  
  //#endregion

  //#region SentenceModal
  const [sentences, setSentences] = useState([]);
  const [originalSentences, setOriginalSentences] = useState([]);
  // const [isSentenceModalVisible, setIsSentenceModalVisible] = useState(false);
  // const [currentSentence, setCurrentSentence] = useState('');
  const [loading, setLoading] = useState(false);
  
  // const for modals
  const [showMediaModal, setShowMediaModal] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setOriginalSentences(selectedSentences); // Store the original fetched data
      setSentences(selectedSentences);
    };
    fetchData();
  }, [selectedSentences]);

  useEffect(() => {
    if (
      selectedOperation === OPERATION_MODES.GESTALTEN || selectedOperation === OPERATION_MODES.AUFNEHMEN &&
      onAuthoringClick &&
      //  &&
      sentences.length > 0
    ) {
      const currentSentence =
        sentences[(currentPage - 1) * pageSize] || sentences[0];
      const associatedCharacter = selectedCharacters.find(
        (character) => character.id === currentSentence.characterid
      );
      // const hasAuthoringPermission = assignedUsers[
      //   currentSentence.characterid
      // ]?.[currentUser.id]?.tasks.includes("enrichments");

      // if (hasAuthoringPermission) {
        onAuthoringClick(currentSentence, null, associatedCharacter);
      // } else {
        // message.warning(
        //   "Du hast keine Berechtigung, die Sätze für diesen Charakter zu gestalten."
        // );
      // }
    }
  }, [navToGestaltenPage]);


  // Auslosen Mode session states
  const [sessionValue, setSessionValue] = useState(null);
  const sessionRef = useRef(null);
  const [sessionActive, setSessionActive] = useState(false);
  
  useEffect(() => {
      const fetchRaumPermissions = async () => {
        try {
          const response = await axios.get(`/api/groups/${currentGroupId}`); // Fetch all groups
  
          console.log("Fetched Raumpermissions:", response);
          const permissions = {};
  
          // console.log("Fetched Raumpermissions:", response);
          setSessionValue(response.data.sid_dmc); // Update state with all permissions
          sessionRef.current = response.data.sid_dmc;
          await handleJoinSession();
        } catch (error) {
          console.error("Error fetching raum permissions:", error);
        }
      };
  
      // if (groups.length > 0) {
      fetchRaumPermissions();
      // }
    }, []);
    const handleJoinSession = async () => {
      try {
        const socket = await connectWebSocket();
        socket.emit("join-session", sessionRef.current);
  
        console.log("Joining Session:", sessionRef.current);
        socket.on("user-joined", (id) => {
          console.log(`New user joined Session: ${id.session_id}`);
          console.log(`User Sid: ${id.user_session_id}`);
          showMessageSuccess(`New user joined:${id.session_id}`);
          setSessionActive(true);
        });
        socket.on("session-error", (msg) => {
          // alert(msg);
          showMessageError(msg);
        });
      } catch (error) {
        console.error("Error joining session:", error);
      }
    };

  // Notification const
  const Context = React.createContext({
    name: "Casting",
  });

  // Cleanup QR scanner when component unmounts
  useEffect(() => {
    return () => {
      setScannerEnabled(false);
    };
  }, []);

  // Handle QR scan result
  const handleQrResult = (resultText) => {
    try {
      // Try to parse as JSON first (for complex QR codes)
      const qrData = JSON.parse(resultText);
      vlog("QR Code data:", qrData);
      
      // Process the QR data - you can customize this based on your needs
      message.success("QR-Code erfolgreich gescannt!");
      
      // Example processing - adjust based on your QR code structure
      if (qrData.sessionId) {
        // This is a DMC session ID QR code
        vlog("DMC Session ID detected:", qrData.sessionId);
        // Connect to the DMC session
        connectToDmcSession(qrData.sessionId);
      } else if (qrData.storyId || qrData.groupId) {
        // This is likely a valid STREEN QR code
        vlog("Valid STREEN QR code detected");
        // Add your specific logic here
      }
      
      // Close the modal after successful scan
      setIsQrScannerVisible(false);
      setScannerEnabled(false);
      setQrError(null);
      
    } catch (e) {
      // If not JSON, treat as plain text (likely just a session ID)
      vlog("QR Code text:", resultText);
      
      // Check if it looks like a session ID (typical DMC session ID pattern)
      if (resultText.length > 20 && /^[a-zA-Z0-9]+$/.test(resultText)) {
        // This looks like a session ID
        message.success("Session ID erfolgreich erkannt!");
        connectToDmcSession(resultText);
        setIsQrScannerVisible(false);
        setScannerEnabled(false);
        setQrError(null);
      } else if (resultText.includes("STREEN") || resultText.includes("streen")) {
        message.success("QR-Code erfolgreich gescannt!");
        setIsQrScannerVisible(false);
        setScannerEnabled(false);
        setQrError(null);
      } else {
        setQrError("Dies scheint kein gültiger STREEN QR-Code zu sein.");
      }
    }
  };

  // Connect to DMC session
  const connectToDmcSession = (sessionId) => {
    vlog("Connecting to DMC session:", sessionId);
    
    // Update the connection status
    setHasDMCControl(true);
    
    // In a real implementation, you would send this to your backend
    // to establish the connection between client and DMC
    
    message.success({
      content: `✓ Erfolgreich verbunden mit Session ID: ${sessionId}`,
      duration: 5,
    });
    
    // Example of what you might do in a real implementation:
    // axios.post('/api/dmc/connect', { 
    //   sessionId: sessionId, 
    //   userId: currentUser.id,
    //   storyId: storyId,
    //   groupId: currentGroupId 
    // })
    //   .then(response => {
    //     vlog("Connected to DMC session successfully");
    //     // Update UI to show connected state
    //     setHasDMCControl(true);
    //   })
    //   .catch(error => {
    //     vlog("Failed to connect to DMC session:", error);
    //     message.error("Verbindung zur DMC-Session fehlgeschlagen");
    //     setHasDMCControl(false);
    //   });
  };

  //#region pagination
  // Pagination state

  const [lastPage, setLastPage] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(3); // default items per page
  const carouselRef = useRef(null);
  const totalPages = Math.ceil(sentences.length / pageSize);
  // Calculate paginated sentences for current page
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedSentences = sentences.slice(startIndex, endIndex);
  const isCarouselUpdate = useRef(false);
  //  useEffect(() => {
  //    // Restore the currentPage from lastPage
  //    const storedPage = localStorage.getItem("lastPage");
  //    setLastPage(storedPage);
  //    setCurrentPage(Number(storedPage));
  //    // carouselRef.current.goTo(storedPage - 1, true);
  //  }, []);
  const onPageChange = (page, newPageSize) => {
    setPageSize(newPageSize); // Update pageSize if it changes

    setCurrentPage(page); // Update the current page
    if (carouselRef.current) {
      carouselRef.current.goTo(page - 1, true);
      localStorage.setItem("lastPage", page);
    }
  };

  const handleCarouselChange = (index) => {
    // isCarouselUpdate.current = true;

    localStorage.setItem("lastPage", index + 1);

    setCurrentPage(index + 1); // Update the current page
    // setLastPage(index + 1);
    vlog("last page::", lastPage);
  };
  //  useEffect(() => {
  //    const storedPage = localStorage.getItem("lastPage");

  //    if (storedPage) {
  //     vlog("storedPage:::", storedPage);
  //     // carouselRef.current.goTo(Number(storedPage) - 1, true);
  //    }
  //  }, []);

  //#endregion pagination

  //region tasks
  const [tasks, setTasks] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState({}); // Store assigned users per sentence
  const [feedbackTasks, setFeedbackTasks] = useState({});

  const getAssignedUser = (sentence) => {
    if (!tasks.length) return null;

    // Find the task that matches the sentence’s character
    const task = tasks.find((t) => t.character_id === sentence.character_id);

    return task ? task.assignee : null; // 'assignee' is the user ID
  };

  // Maps frontend operation to backend task category
  const operationTaskMap = {
    authoring: "enrichments",
    record: "record",
    feedback: "feedback",
    highlight: "highlight",
    word_clarification: "word_clarification",
    effects: "effects",
    word_cloud: "wc", // or analyse if your backend uses that spelling
    edit: "edit",
  };

  // Reusable helper: find the current user assigned to a specific operation
  const getCurrentUserTaskEntry = (characterId, operation) => {
    const usersForCharacter = Object.values(assignedUsers[characterId] || {});
    const taskName = operationTaskMap[operation]?.toLowerCase();

    return usersForCharacter.find(
      (user) =>
        user.userId === currentUser.id &&
        user.tasks.some((t) => t.toLowerCase() === taskName)
    );
  };

  const getUserForOperation = (characterId, operation, currentUser) => {
    vlog("operation", operation);

    if (operation == OPERATION_MODES.AUSLOSEN) operation = OPERATION_MODES.GESTALTEN;

    vlog("operation New", operation);

    const usersForCharacter = Object.values(assignedUsers[characterId] || {});
    const taskName = operationTaskMap[operation]?.toLowerCase();

    // Find current user with this task
    const currentUserEntry = usersForCharacter.find(
      (user) =>
        user.userId === currentUser.id &&
        user.tasks.some((t) => t.toLowerCase() === taskName)
    );

    // Find another user if current user doesn’t have this task
    const otherUserEntry = usersForCharacter.find(
      (user) =>
        user.userId !== currentUser.id &&
        user.tasks.some((t) => t.toLowerCase() === taskName)
    );

    return currentUserEntry || otherUserEntry || null;
  };

  //#endregion tasks

  //region IllusMakerConstants
  const [illusOpen, setIllusOpen] = useState(false);
  const [currentIllusSentence, setCurrentIllusSentence] = useState(null);
  const [selectedWordSpanID, setSelectedWordSpanID] = useState(null);
  
  const [illusmakerPosition, setIllusmakerPosition] = useState({
    top: "50%",
    left: "50%",
  });
  const [illusmakerSize, setIllusmakerSize] = useState({
    width: "50vw",
    height: "50vh",
  });
  const [illusmakerZIndex, setIllusmakerZIndex] = useState({ zIndex: -1 });
  const [isTransparent, setIsTransparent] = useState(false);
  const [isSavingEnrichment, setIsSavingEnrichment] = useState(false);
  const calculateIllusmakerSize = () => {
    let maxWidth = 0;
    // alert(window.innerWidth);
    let samsungTablet6LiteLandscape = 1333;
    if (window.innerWidth == samsungTablet6LiteLandscape) {
      maxWidth = Math.min(window.innerWidth * 0.61, 1200);
    } else maxWidth = Math.min(window.innerWidth * 0.9, 1200);

    const height = window.innerHeight * 0.9;
    return {
      width: `${maxWidth}px`,
      height: `${height}px`,
    };
  };
  const handleIllusModal = (state) => {
    setIllusOpen(state);
    setIllusmakerSize(calculateIllusmakerSize());
    setIllusmakerPosition({ top: "50%", left: "50%" });
    setIllusmakerZIndex(1000);
    toggleTransparency(false);
    vlog("click word");
    return state;
  };
  useEffect(() => {
    const handleResize = () => {
      if (illusOpen) {
        setIllusmakerSize(calculateIllusmakerSize());
        setIllusmakerPosition({ top: "50%", left: "50%" });
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [illusOpen]);
  const toggleTransparency = (value) => {
    setIsTransparent(value);
  };

  const minimizeIllusmaker = () => {
    toggleTransparency(true);
    setIllusmakerSize({ width: "5vw", height: "5vh" });
    setIllusmakerPosition({ top: "10%", left: "50%" });
    setIllusmakerZIndex(-1000);
  };

  //endregion IllusMakerConstants
  const handleWordSpanIdChange = (w) => {
    setSelectedWordSpanID(w);
  };
  // const handleAddEnrichment = async (
  //   sentence,
  //   wordSpanIndex,
  //   blobData,
  //   enrichment
  // ) => {
  //   // Implement Trigger functionality
  //   vlog("handleAddEnrichment:::enrichment:::", enrichment);
  //   vlog("handleAddEnrichment:::", sentence);

  //   try {
  //     let response = null;
  //     const data = {
  //       storyid: sentence.storyid,
  //       sentenceid: sentence.id,
  //       userid: currentUser.id,
  //       wordspanid: wordSpanIndex,
  //       type: "default",
  //       specification: "default",
  //       illusdata: blobData,
  //       illusdata_str: blobData,
  //       group_id: currentGroupId || 0, // Default to 0 if not provided
  //       visibility: currentVisibility || "private", // Default to 'private'
  //     };
  //     if (enrichment === undefined) {
  //       // vlog("setSelectedEnrichment:post::",enrichment);
  //       response = await axios.post(`/api/enrichments/`, data);
  //     } else {
  //       // vlog("setSelectedEnrichment:put::",enrichment);
  //       response = await axios.put(`/api/enrichments/${enrichment.id}`, data);
  //     }

  //     vlog("enrichment created:", response.data);
  //     const underlineResponse = await axios
  //       .get(`/api/enrichments/`, {
  //         params: {
  //           storyid: storyId,
  //           userid: currentUser.id, // Needed to check private enrichments
  //           groupId: Number(currentGroupId) || 0, // Needed to check group enrichments
  //         },
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching enrichments:", error);
  //       });

  //     setStoryEnrichments(underlineResponse.data);
  //     // Update the state with the new highlight
  //     // setStoryHighlights([...storyHighlights, response.data]);

  //     // Navigate to illusmaker with selected word or sentence
  //     // const selectedWord =
  //     //   typeof sentenceIndex === "string" ? sentence.id.split("_")[1] : "";

  //     // const selectedSentence = selectedSentences.find(
  //     //   (sentence) => sentence.id === sentence.id
  //     // );

  //     // Navigate to the illusmaker page with the selected word and sentence
  //     // navigate("/illusmaker", {
  //     //   state: {
  //     //     selectedWord,
  //     //     selectedSentenceText: selectedSentence.text,
  //     //     selectedStory,
  //     //   },
  //     // });
  //     vlog("is saving complete:");
  //   } catch (error) {
  //     console.error("Error creating enrichment:", error);
  //   } finally {
  //     setIsSavingEnrichment(false);
  //   }
  // };

  function lightenColor(hexColor, percent) {
    // Remove the "#" if it exists
    const color = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;

    // Convert the hex color to RGB
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);

    // Calculate the lighter RGB values
    const lighten = (value) =>
      Math.min(255, Math.floor(value + (255 - value) * (percent / 100)));
    const newR = lighten(r);
    const newG = lighten(g);
    const newB = lighten(b);

    // Convert the new RGB values back to hex
    const toHex = (value) => value.toString(16).padStart(2, "0");
    const newHexColor = `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;

    return newHexColor;
  }

  function rgbToHex(rgb) {
    // Extract the numeric values from the rgb string
    const rgbValues = rgb.match(/\d+/g);
    if (!rgbValues || rgbValues.length < 3) return null; // Invalid RGB format

    const r = parseInt(rgbValues[0], 10); // Red
    const g = parseInt(rgbValues[1], 10); // olive1
    const b = parseInt(rgbValues[2], 10); // Blue

    // Convert each value to a 2-digit hexadecimal
    const toHex = (value) => value.toString(16).padStart(2, "0");

    // Combine the hex values
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  useEffect(() => {
    if (!currentGroupId || !storyId || !currentUser) return;

    const fetchTasks = async () => {
      try {
        const response = await axios.get(
          `/api/tasks/groups/${currentGroupId}/tasks-with-users`,
          {
            params: { storyId: storyId },
          }
        );

        const taskData = response.data;
        setTasks(taskData);
        vlog("taskData:_::::::::", taskData);

        const usersMap = {};
        const feedbackMap = {}; // Maps character_id to users with "feedback" tasks
        let canRecord = false;
        let canEnrich = false;

        taskData.forEach((task) => {
          if (task.character_id) {
            // Ensure a map exists for each character
            if (!usersMap[task.character_id]) {
              usersMap[task.character_id] = {};
            }

            // Ensure a map entry for each user per character
            if (!usersMap[task.character_id][task.member_id]) {
              usersMap[task.character_id][task.member_id] = {
                userId: task.member_id,
                username: task.username,
                tasks: [],
              };
            }

            // Push the task category
            usersMap[task.character_id][task.member_id].tasks.push(
              task.category
            );

            // If the task is "feedback", add it to feedbackMap
            if (task.category === "feedback") {
              if (!feedbackMap[task.character_id]) {
                feedbackMap[task.character_id] = [];
              }
              feedbackMap[task.character_id].push({
                userId: task.member_id,
                username: task.username,
              });
            }

            vlog("taskCATE:_::::::::", usersMap);
            //TODO remove below unused flags e.g. canEnrich
            // Check if the current user has recording rights
            if (
              task.member_id === currentUser.id &&
              task.category === OPERATION_MODES.AUFNEHMEN
            ) {
              canRecord = true;
            }

            // Check if the current user has enrichment rights
            if (
              task.member_id === currentUser.id &&
              task.category === "enrichments"
            ) {
              canEnrich = true;
            }
          }
        });

        setAssignedUsers(usersMap);
        setFeedbackTasks(feedbackMap);
        vlog("usersMap:_::::::::", usersMap);
        vlog("feedbackMap:_::::::::", feedbackMap);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };

    fetchTasks();
  }, [currentGroupId, storyId, currentUser]);

  const [hasDMCControl, setHasDMCControl] = useState(false);
  const [audioMode, setAudioMode] = useState("standard"); // "standard" or "recorded"

  // QR Scanner Modal state
  const [isQrScannerVisible, setIsQrScannerVisible] = useState(false);
  const [scannerEnabled, setScannerEnabled] = useState(false);
  const [qrError, setQrError] = useState(null);

  // Function to fetch permissions
  const fetchDMCControlPermission = async () => {
    try {
      const response = await axios.get("/api/groups/dmc"); // Fetch groups with permission
      const allowedGroups = response.data; // Array of groups with DMC control

      const isAllowed = allowedGroups.some(
        (group) => Number(group.id) === Number(currentGroupId)
      );
      vlog("Permission check result:", isAllowed);

      setHasDMCControl(isAllowed);
      return isAllowed; // Return result for synchronous-like behavior
    } catch (error) {
      console.error("Error fetching DMC control permissions:", error);
      return false; // Default to false on error
    }
  };
  // Handle scroll to make FAB button sticky
    const [isFabSticky, setIsFabSticky] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        // Check scroll position and update sticky state
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // Make button sticky when scrolled down about 126px (138px initial - 12px sticky position)
        setIsFabSticky(scrollTop > 126);
      };
  
      // Add scroll event listener
      window.addEventListener('scroll', handleScroll);
      
      // Clean up event listener on component unmount
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  /// useEffect runs once when the component mounts
  useEffect(() => {
    fetchDMCControlPermission(); // Initial check
  }, [currentUser]);

  // Cleanup highlighted words when operation changes
  useEffect(() => {
    if (selectedOperation !== OPERATION_MODES.SAMMELN) {
      setHighlightedWords([]);
      setDrawerVisible(false);
      setSelectedSammelnOption(null);
    }
  }, [selectedOperation]);

  // Function to clear all highlighted words
  const clearAllHighlights = () => {
    // Reset background colors of all highlighted words
    highlightedWords.forEach(item => {
      const wordElement = document.getElementById(item.wordSpanId);
      if (wordElement) {
        // Find the associated character to get the original color
        const sentence = selectedSentences.find(s => s.id === item.sentenceId);
        if (sentence) {
          const associatedCharacter = selectedCharacters.find(
            character => character.id === sentence.characterid
          );
          if (associatedCharacter) {
            wordElement.style.backgroundColor = associatedCharacter.color;
          }
        }
      }
    });
    setHighlightedWords([]);
  };

  // Helper function to stop recorded audio playback
  const stopRecordedAudio = () => {
    if (playingRecordedAudioRef.current) {
      playingRecordedAudioRef.current.pause();
      playingRecordedAudioRef.current = null;
    }
    setPlayingRecordedAudio(null);
  };

  // Helper function to play recorded audio or fallback to TTS
  const playRecordedOrTTS = async (sentence) => {
    if (audioMode === "recorded") {
      try {
        // Determine mode based on whether we have a group ID
        const mode = currentGroupId ? "group" : "user";
        
        // Try to fetch recorded audio for this sentence
        const audioRecord = await fetchRecordedAudio({
          userId: currentUser.id,
          storyId: storyId,
          sentenceId: sentence.id,
          groupId: currentGroupId || 0,
          mode: mode
        });
        
        if (audioRecord) {
          // Play recorded audio
          const audio = new Audio(`/api/audioRecords/audiofile?fileName=${audioRecord.file_path}`);
          
          // Store reference to the audio element
          playingRecordedAudioRef.current = audio;
          
          // Set state to indicate this sentence's recorded audio is playing
          setPlayingRecordedAudio(sentence.id);
          
          // Handle audio events
          audio.onplay = () => {
            vlog("Recorded audio started playing");
          };
          
          audio.onended = () => {
            // Clear the playing state when audio finishes
            playingRecordedAudioRef.current = null;
            setPlayingRecordedAudio(null);
          };
          
          audio.onerror = (e) => {
            vlog("Error playing recorded audio:", e);
            // Clear the playing state on error
            playingRecordedAudioRef.current = null;
            setPlayingRecordedAudio(null);
            // Fall back to TTS
            setActiveReadAloudWordId(null);
            startSentence(sentence.id, sentence.text);
          };
          
          audio.play();
          return;
        }
        // If no recorded audio found, fall back to TTS
      } catch (error) {
        vlog("Error fetching recorded audio:", error);
        // Fall back to TTS on error
      }
    }
    
    // Play TTS as fallback
    setPlayingRecordedAudio(null); // Clear recorded audio state
    setActiveReadAloudWordId(null);
    startSentence(sentence.id, sentence.text);
  };

  return (
    <div className="reader-mode">
      
        <React.Fragment>
          <ConfigProvider
            theme={{
              components: {
                Carousel: {
                  arrowSize: 64,
                },
              },
            }}
          >
            
            
            
            {/* Vorlesen header panel - positioned above Carousel */}
            {selectedOperation === OPERATION_MODES.VORLESEN && (
              <Flex className={`header-panel-right ${isFabSticky ? "sticky" : ""}`} vertical>
                <Flex align="stretch" style={{ width: "100%", height: "100%" }}>
                  {/* Icons column (width: 2) */}
                  <div>
                    {/* Read aloud button */}
                    <Button
                      type="text"
                      size="middle"
                      title={
                        isPageTtsPlaying
                          ? isPageTtsPaused
                            ? "Fortsetzen"
                            : "Pausieren"
                          : "Alle vorlesen"
                      }
                      onClick={async () => {
                        // If currently playing and not paused, pause it
                        if (isPageTtsPlaying && !isPageTtsPaused) {
                          setIsPageTtsPaused(true);
                          stopSentence(); // Stop current sentence
                          // Also stop recorded audio if playing
                          if (playingRecordedAudioRef.current) {
                            playingRecordedAudioRef.current.pause();
                            playingRecordedAudioRef.current = null;
                            setPlayingRecordedAudio(null);
                          }
                          return;
                        }
                        
                        // If currently paused, resume
                        if (isPageTtsPlaying && isPageTtsPaused) {
                          setIsPageTtsPaused(false);
                          // Resume from where we left off
                          if (pageTtsQueue.length > 0 && pageTtsIndex >= 0) {
                            const currentSentence = pageTtsQueue[pageTtsIndex];
                            if (currentSentence) {
                              // For recorded mode, try to play recorded audio first
                              await playRecordedOrTTS(currentSentence);
                            }
                          }
                          return;
                        }
                        
                        // If not playing, start playing
                        const samePageQueue =
                          pageTtsQueue.length === paginatedSentences.length &&
                          pageTtsQueue.every((s, idx) => s.id === paginatedSentences[idx]?.id);

                        if (samePageQueue && isPageTtsPlaying && !isPageTtsPaused) {
                          stopSentence();
                          stopPageReadAloud();
                          // Also stop recorded audio if playing
                          if (playingRecordedAudioRef.current) {
                            playingRecordedAudioRef.current.pause();
                            playingRecordedAudioRef.current = null;
                            setPlayingRecordedAudio(null);
                          }
                          return;
                        }

                        if (!paginatedSentences.length) return;

                        const queue = paginatedSentences.map((s) => ({
                          id: s.id,
                          text: s.text,
                        }));

                        setActiveReadAloudWordId(null);
                        setPageTtsQueue(queue);
                        setPageTtsIndex(0);
                        setIsPageTtsPlaying(true);
                        setIsPageTtsPaused(false);
                        
                        // For recorded mode, try to play recorded audio first
                        await playRecordedOrTTS(queue[0]);
                      }}
                    >
                      <img
                        src={isPageTtsPlaying
                          ? isPageTtsPaused
                            ? play_icon
                            : pause_icon
                          : speech_icon}
                        alt={isPageTtsPlaying
                          ? isPageTtsPaused
                            ? "Fortsetzen"
                            : "Pausieren"
                          : "Vorlesen"}
                        style={{
                          width: "28px",
                          height: "28px",
                        }}
                      />
                    </Button>
                  </div>
                  
                  {/* Text column (width: 3) */}
                  <div>
                    {selectedOperation === OPERATION_MODES.VORLESEN ? (
                      <div>
                        <Radio.Group value={audioMode} onChange={(e) => setAudioMode(e.target.value)}>
                          <Space direction="vertical">
                            <Radio value="standard">Standardstimme</Radio>
                            <Radio value="recorded">Aufgezeichnete Stimme</Radio>
                          </Space>
                        </Radio.Group>
                      </div>
                    ) : (
                      <div>
                        Kein Raum verbunden 🔴
                      </div>
                    )}
                  </div>
                </Flex>
              </Flex>
            )}
            {/* Sammeln header panel - positioned above Carousel */}
            {selectedOperation === OPERATION_MODES.SAMMELN && (
              <Dropdown 
                menu={{
                  items: taskRegistry.sammeln_single_user.descriptions.map((option) => ({
                    key: option.id,
                    label: option.label,
                    onClick: () => {
                      // Handle selection change
                      vlog("Selected sammeln option:", option.id);
                      setSelectedSammelnOption(option);
                    }
                  }))
                }}
                trigger={['click']}
                overlayClassName="header-panel-sammeln-dropdown"
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                placement="bottomRight"
              >
                  <Flex className={`header-panel-right header-panel-sammeln-content ${isFabSticky ? "sticky" : ""}`} vertical>
                    <Flex align="stretch" style={{ width: "100%", height: "100%" }}>
                      
                      <div>
                        <div style={{ 
                          width: '100%', 
                          height: '100%', 
                          display: 'flex', 
                          flexDirection: 'column', 
                          justifyContent: 'center', 
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}>
                          {selectedSammelnOption ? (
                            <>
                              <Space direction="horizontal">
                                <img 
                                src={sammeln_header_menu_mini_icon} 
                                alt="Sammeln" 
                                style={{ width: "20px", height: "19px" }} 
                              />
                              <Typography.Text className="text-typography-tagline">
                                Aufgabe
                              </Typography.Text>
                              </Space>
                              <Typography.Text className="text-typography-sub">
                                {selectedSammelnOption.text}
                              </Typography.Text>
                            </>
                          ) : (
                            <>
                              <img 
                                src={sammeln_header_menu_main_icon} 
                                alt="Sammeln" 
                                style={{ width: "29px", height: "29px", marginBottom: "4px" }} 
                              />
                              <Typography.Text className="text-typography-main">
                                Aufgabe wählen
                              </Typography.Text>
                            </>
                          )}
                        </div>
                      </div>
                    </Flex>
                  </Flex>
               
              </Dropdown>
            )}
            {/* Auslosen header panel - positioned above Carousel */}
            {selectedOperation === OPERATION_MODES.AUSLOSEN && (
              <Flex className={`header-panel-right header-panel-auslosen-content ${isFabSticky ? "sticky" : ""}`} vertical>
                <Flex align="stretch" style={{ width: "100%", height: "100%" }}>
                  {/* Icons column (width: 2) */}
                  <div>
                    {/* Read aloud button */}
                    {selectedOperation === OPERATION_MODES.AUSLOSEN ? (
                      <Space direction="vertical" align="center">
                      <div>
                          <img 
                            src={hasDMCControl ? conn_icon : no_conn_icon} 
                            alt={hasDMCControl ? "Connected to DMC" : "Not connected to DMC"}
                            style={{ width: "24px", height: "24px" }}
                          />
                      </div>
                      <div>
                        {hasDMCControl ? "Verbunden" : "Keine Verbindung"}
                      </div>
                      {hasDMCControl && (
                        <div>
                          <Typography.Text type="success" style={{ fontSize: "12px" }}>
                            ✓ Verbunden
                          </Typography.Text>
                          <div style={{ marginTop: "4px" }}>
                            <Button 
                              type="link" 
                              size="small"
                              onClick={() => {
                                setHasDMCControl(false);
                                message.info("Verbindung getrennt");
                              }}
                              style={{ padding: 0, height: "auto" }}
                            >
                              Trennen
                            </Button>
                          </div>
                        </div>
                      )}
                      
                      </Space>
                    ) : (
                      <div>
                        
                      </div>
                    )}
                  </div>
                  
                  {/* Text column (width: 3) */}
                  <div>
                    <Space direction="vertical" align="center">
                      <div>
                          <Button 
                            // type="primary" 
                            // shape="circle" 
                            icon={<img src={scan_qr_icon} alt="Scan QR" style={{ width: "29px", height: "29px" }} />}
                            onClick={() => {
                              // Check browser compatibility before opening QR scanner
                              if (typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices) {
                                message.error("Kamerafunktion wird von diesem Browser nicht unterstützt. Bitte verwende einen modernen Browser mit HTTPS.");
                                return;
                              }
                              
                              // Open QR scanner modal
                              setIsQrScannerVisible(true);
                              setScannerEnabled(true);
                              setQrError(null);
                            }}
                            className="header-panel-qr-scann"
                          />
                      </div>
                      <div>
                        QR Scannen 
                      </div>
                      
                  </Space>
                  </div>
                </Flex>
              </Flex>
            )}
            <Carousel
              // arrows
              id="carousel"
              ref={carouselRef}
              infinite={false}
              dots={false}
              afterChange={handleCarouselChange}
              // beforeChange={() => {
              //   // if (carouselRef.current) {
              //   //   carouselRef.current.goTo(currentPage-1);
              //   //   // setCurrentPage(currentPage + 1);
              //   // }

              // }}
            >
              {Array.from({ length: totalPages }, (_, i) => {
                const startIndex = i * pageSize;
                const endIndex = startIndex + pageSize;
                const paginatedSentences = sentences.slice(
                  startIndex,
                  endIndex
                );

                return (
                  <ul className="reader-mode-story-sentence-list" key={i}>
                    
                    {paginatedSentences.map((sentence, sentenceIndex) => {
                      const associatedCharacter = selectedCharacters.find(
                        (character) => character.id === sentence.characterid
                      );

                      const highlightsForSentence = storyHighlights.filter(
                        (highlight) => highlight.sentenceid === sentence.id
                      );
                      // vlog("storyEnrichments:::",storyEnrichments)
                      const enrichmentsForSentence = storyEnrichments.filter(
                        (enrichment) => enrichment.sentenceid === sentence.id
                      );
                      const sentencePlainText = sanitizeTtsText(sentence.text);
                      const activeWordIndex =
                        selectedOperation === OPERATION_MODES.VORLESEN
                          ? getSentenceWordIndex(sentence.id, sentence.text)
                          : null;

                      const handleRecordingComplete = (
                        sentenceId,
                        audioBlob
                      ) => {
                        vlog(
                          "Recording complete for sentence:",
                          sentenceId,
                          audioBlob
                        );
                        // You can handle audioBlob here, e.g., upload it or save it to state
                      };

                      return (
                        <li key={sentence.id} className="sentence">
                          <main
                            className="character-block-container"
                            style={{
                              backgroundColor: `${associatedCharacter.color}`,
                              // border: `5px solid ${lightenColor(
                              //   `${associatedCharacter.color}`,
                              //   30
                              // )}`,
                            }}
                            onDoubleClick={() => {
                              // Navigate to Studio page with sentence data
                              navigate('/Studio', {
                                state: {
                                  sentence: sentence,
                                  wordSpanId: `word_${sentence.id}_0`,
                                  selectedSentences: selectedSentences,
                                  selectedCharacters: selectedCharacters,
                                  groupId: currentGroupId,
                                  storyTitle: storyTitle,
                                  selectedStory: { storyId: storyId },
                                  selectedOperation: selectedOperation === OPERATION_MODES.VORLESEN ? OPERATION_MODES.AUFNEHMEN : selectedOperation
                                }
                              });
                            }}
                            onTouchEnd={(e) => {
                              // Handle double tap on touch devices
                              const currentTime = new Date().getTime();
                              const tapTimeDiff = currentTime - lastTapTime.current;
                              
                              if (tapTimeDiff < 300 && tapTimeDiff > 0) {
                                // Double tap detected
                                e.preventDefault();
                                navigate('/Studio', {
                                  state: {
                                    sentence: sentence,
                                    wordSpanId: `word_${sentence.id}_0`,
                                    selectedSentences: selectedSentences,
                                    selectedCharacters: selectedCharacters,
                                    groupId: currentGroupId,
                                    storyTitle: storyTitle,
                                    selectedStory: { storyId: storyId },
                                    selectedOperation: selectedOperation === OPERATION_MODES.VORLESEN ? OPERATION_MODES.AUFNEHMEN : selectedOperation
                                  }
                                });
                              }
                              
                              lastTapTime.current = currentTime;
                            }}
                          >
                            <div className="character-block-left">
                              <span className="character-block-number">
                                {sentence.ord}
                              </span>
                            </div>

                            {associatedCharacter && (
                              <div className="character-block-center">
                                <div className="character-block-top">
                                  <div className="character-content">
                                    <CharacterImage
                                      filename={associatedCharacter.img}
                                      name={associatedCharacter.name}
                                      storyId={associatedCharacter.storyId}
                                      src={"pubup"}
                                    />
                                    <aside className="character-name">
                                      {associatedCharacter.name}:
                                    </aside>
                                    {selectedOperation === OPERATION_MODES.VORLESEN && (
                                      <Button
                                        type="text"
                                        size="small"
                                        onClick={async () => {
                                          // Don't interfere with page-level TTS if it's playing
                                          if (isPageTtsPlaying && !isSentenceSpeaking(sentence.id) && playingRecordedAudio !== sentence.id) {
                                            // Just ignore the click or show a message
                                            return;
                                          } else {
                                             stopPageReadAloud(); 
                                          }

                                          // If recorded audio is playing for this sentence, stop it
                                          if (playingRecordedAudio === sentence.id) {
                                            stopRecordedAudio();
                                            return;
                                          }

                                          // If TTS is playing for this sentence, stop it
                                          if (isSentenceSpeaking(sentence.id)) {
                                            setActiveReadAloudWordId(null);
                                            stopSentence();
                                            return;
                                          }

                                          // Play recorded audio or TTS based on selected mode
                                          await playRecordedOrTTS(sentence);
                                        }}
                                        title={
                                          isPageTtsPlaying
                                            ? "Seitenweitergabe aktiv"
                                            : playingRecordedAudio === sentence.id
                                              ? "Vorlesen stoppen"
                                              : isSentenceSpeaking(sentence.id)
                                                ? "Vorlesen stoppen"
                                                : "Vorlesen starten"
                                        }
                                        disabled={isPageTtsPlaying && !isSentenceSpeaking(sentence.id) && playingRecordedAudio !== sentence.id}
                                      >
                                        <img
                                          src={isPageTtsPlaying && !isSentenceSpeaking(sentence.id) && playingRecordedAudio !== sentence.id
                                            ? speech_icon
                                            : playingRecordedAudio === sentence.id || isSentenceSpeaking(sentence.id)
                                              ? stop_icon
                                              : speech_icon}
                                          alt={isPageTtsPlaying && !isSentenceSpeaking(sentence.id) && playingRecordedAudio !== sentence.id
                                            ? "Seitenweitergabe aktiv"
                                            : playingRecordedAudio === sentence.id || isSentenceSpeaking(sentence.id)
                                              ? "Stoppen"
                                              : "Vorlesen"}
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                            // opacity: isPageTtsPlaying && !isSentenceSpeaking(sentence.id) && playingRecordedAudio !== sentence.id ? 0.5 : 1,
                                          }}
                                        />
                                      </Button>
                                    )}
                                    {/* Auslosen style */}
                                    {selectedOperation === OPERATION_MODES.AUSLOSEN && (
                                      <div style={{ display: "flex", gap: "16px", marginLeft: "auto" }}>
                                        {/* <Button 
                                          className="auslosen-mode auslosen-mode-button"
                                          icon={}
                                          onClick={() => {
                                            // TODO: Implement projector functionality
                                            vlog("Projektor button clicked");
                                          }}
                                        /> */}
                                        <Button 
                                          className="auslosen-mode auslosen-mode-button"
                                          icon={<img 
                                            src={hasDMCControl && enrichmentsForSentence.length > 0 ? projector_enabled_icon : projector_disabled_icon} 
                                            alt={hasDMCControl && enrichmentsForSentence.length > 0 ? "Projektor aktiviert" : "Projektor deaktiviert"} 
                                            style={{ width: "29px", height: "29px" }} 
                                          />}
                                          onClick={() => {
                                            // TODO: Implement projector functionality
                                            vlog("Projektor button clicked");
                                            // TODO: Log the enrichment data here when clicked
                                            vlog("AUSLOSEN:::Sentence Enrichment:::", enrichmentsForSentence);
                                          }}
                                          disabled={!hasDMCControl || enrichmentsForSentence.length === 0}
                                        />
                                        <Button 
                                          className="auslosen-mode auslosen-mode-button"
                                          icon={<img 
                                            src={gallery_icon} 
                                            alt="Galerie" 
                                            style={{ width: "29px", height: "29px" }} 
                                          />}
                                          onClick={() => {
                                            // TODO: Log the enrichment data here when clicked
                                            vlog("AUSLOSEN:::Sentence Enrichment:::",enrichmentsForSentence);
                                            vlog("Gallery button clicked");
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="character-block-bottom">
                                    {sentencePlainText
                                      .split(" ")
                                      .map((word, wordIndex) => {
                                        const wordSpanId = `word_${sentenceIndex}_${wordIndex}`;
                                        const wordSpanIdEnrich = `word_${sentence.id}_${wordIndex}`;
                                        const highlight =
                                          highlightsForSentence.find(
                                            (highlight) =>
                                              highlight.wordspanid ===
                                              wordSpanId
                                            // vlog("highlight.wordspanid:::",highlight.wordspanid)
                                          );

                                        const underlined =
                                          enrichmentsForSentence.find(
                                            (enrichment) =>
                                              enrichment.wordspanid ===
                                              wordSpanIdEnrich
                                            // vlog("enrichment.wordspanid:::",enrichment.wordspanid)
                                          );
                                        
                                        const isCurrentlySpokenWord =
                                          activeWordIndex === wordIndex ||
                                          activeReadAloudWordId === wordSpanId;

                                        return (
                                          <React.Fragment key={wordSpanId}>
                                            <span
                                              key={wordIndex}
                                              id={wordSpanId}
                                              className="sentence-words"
                                              style={{
                                                backgroundColor: isCurrentlySpokenWord
                                                  ? streenTheme.orange4
                                                  : highlight
                                                  ? highlight.color
                                                  : associatedCharacter.color,
                                                  borderRadius: "0.35em",
                                                  padding: "0.05em 0.12em",
                                                textDecoration: underlined
                                                  ? "underline"
                                                  : "",
                                                cursor: underlined
                                                  ? "pointer"
                                                  : "default",
                                              }}
                                              onClick={async (e) => {
                                                const wordElement = e.target;
                                                if (
                                                  selectedOperation ===
                                                  OPERATION_MODES.SAMMELN
                                                ) { 
                                                  // Show drawer if there are already highlighted words
                                                  if (highlightedWords.length > 0 && !drawerVisible) {
                                                    setDrawerVisible(true);
                                                  }
                                                  const characterColor =
                                                    associatedCharacter.color;

                                                  if (
                                                    rgbToHex(
                                                      wordElement.style
                                                        .backgroundColor
                                                    ) ===
                                                    lightenColor(
                                                      `${characterColor}`,
                                                      70
                                                    )
                                                  ) {
                                                    wordElement.style.backgroundColor = `${characterColor}`;
                                                    // Remove word from highlightedWords if it was previously highlighted
                                                    setHighlightedWords(prev => prev.filter(item => item.wordSpanId !== wordSpanId));
                                                  } else {
                                                    wordElement.style.backgroundColor =
                                                      lightenColor(
                                                        `${characterColor}`,
                                                        70
                                                      );
                                                    handleHighlight(
                                                      sentence.id,
                                                      wordSpanId,
                                                      characterColor
                                                    );
                                                    // Add word to highlightedWords
                                                    const wordText = word.replace(/[.,/#!$%^&*;:{}=?\-_`~()\[\]""]/g," ").trim();
                                                    setHighlightedWords(prev => [
                                                      ...prev,
                                                      { 
                                                        word: wordText, 
                                                        wordSpanId, 
                                                        sentenceId: sentence.id,
                                                        sentenceText: sentence.text,
                                                        characterName: associatedCharacter.name,
                                                        color: characterColor
                                                      }
                                                    ]);
                                                    // Show drawer when first word is highlighted
                                                    if (highlightedWords.length === 0) {
                                                      setDrawerVisible(true);
                                                    }
                                                  }
                                                } else if (
                                                  selectedOperation ===
                                                  OPERATION_MODES.ENTDECKEN // entdecken
                                                ) {
                                                  vlog(
                                                    "word clicked:::",
                                                    word
                                                  );
                                                  vlog(
                                                    "word wordSpanId:::",
                                                    wordSpanId
                                                  );
                                                  vlog(
                                                    "sentence clicked:::",
                                                    sentence
                                                  );
                                                  // setCurrentIllusSentence(
                                                  //   sentence
                                                  // );
                                                  // handleWordClarification(
                                                  //   word,
                                                  //   wordSpanId
                                                  // );
                                                } else if (
                                                  selectedOperation ===
                                                  OPERATION_MODES.VORLESEN
                                                ) {
                                                  vlog("vorlesen mode!");
                                                  vlog("word clicked-:::-", word);
                                                  vlog("word wordSpanId:::", wordSpanId);
                                                  vlog("sentence clicked:::", sentence);
                                                  
                                                  // Don't interfere with page-level TTS if it's playing
                                                  if (isPageTtsPlaying) {
                                                    vlog("Page TTS is playing, ignoring word click");
                                                    return;
                                                  }
                                                  
                                                  setCurrentIllusSentence(
                                                      sentence
                                                    );
                                                  setActiveReadAloudWordId(wordSpanId);
                                                  speakText(word);
                                                  // handleWordClarification(
                                                  //   word,
                                                  //   wordSpanId
                                                  // );
                                                } else if (
                                                  selectedOperation ===
                                                  OPERATION_MODES.AUSLOSEN
                                                ) {
                                                  if (currentUser.role != 0) {
                                                    const isAllowed =
                                                      await fetchDMCControlPermission(); // Wait for permission check
                                                    if (!isAllowed) {
                                                      message.error(
                                                        "Deine Gruppe darf im Moment die Medien nicht steuern."
                                                      );
                                                      return; // Stop execution if no permission
                                                    }
                                                  }
                                                  const originalBackgroundColor =
                                                    wordElement.style
                                                      .backgroundColor;
                                                  wordElement.style.backgroundColor =
                                                    associatedCharacter.color;
                                                  const audio = new Audio(
                                                    "/sounds/tick.mp3"
                                                  );
                                                  // audio.volume = 0.1;

                                                  if (
                                                    wordElement.style
                                                      .textDecoration ===
                                                    "underline"
                                                  ) {
                                                    const audioContext =
                                                      new AudioContext();
                                                    const gainNode =
                                                      audioContext.createGain();
                                                    const source =
                                                      audioContext.createMediaElementSource(
                                                        audio
                                                      );
                                                    source.connect(gainNode);
                                                    gainNode.connect(
                                                      audioContext.destination
                                                    );
                                                    // vlog(`Current volume level: ${volumeLevel}`);
                                                    gainNode.gain.value = 0.25;
                                                    audio.play();
                                                    const frame =
                                                      document.createElement(
                                                        "div"
                                                      );
                                                    frame.style.position =
                                                      "fixed";
                                                    frame.style.top = "10px";
                                                    frame.style.right = "10px";
                                                    frame.style.zIndex =
                                                      "999999";
                                                    frame.style.border =
                                                      "1px solid black";
                                                    frame.style.padding = "5px";
                                                    frame.style.background =
                                                      "white";
                                                    const image =
                                                      document.createElement(
                                                        "img"
                                                      );
                                                    image.src = app_logo;
                                                    image.style.width = "160px";
                                                    image.style.height =
                                                      "120px";

                                                    // frame.appendChild(image);
                                                    // document.body.appendChild(frame);
                                                    // setTimeout(() => {
                                                    //   document.body.removeChild(frame);
                                                    // }, 500);
                                                    Notifications({
                                                      placement: "bottomRight",
                                                      message:
                                                        "Casting Enrichment",
                                                      description: (
                                                        <Context.Consumer>
                                                          {({ frame }) => (
                                                            <div
                                                              style={{
                                                                position:
                                                                  "relative",
                                                                width: "160px",
                                                                height: "120px",
                                                              }}
                                                            >
                                                              <img
                                                                src={app_logo}
                                                                alt="app logo"
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  top: 0,
                                                                  left: 0,
                                                                  width: "100%",
                                                                  height:
                                                                    "100%",
                                                                }}
                                                              />
                                                              {frame}
                                                            </div>
                                                          )}
                                                        </Context.Consumer>
                                                      ),
                                                    });
                                                    handleEnrichment(
                                                      storyId,
                                                      sentence.id,
                                                      wordSpanIdEnrich
                                                    );
                                                  } else {
                                                    audio.src =
                                                      "/sounds/wronganswer.mp3";
                                                    const audioContext =
                                                      new AudioContext();
                                                    const gainNode =
                                                      audioContext.createGain();
                                                    const source =
                                                      audioContext.createMediaElementSource(
                                                        audio
                                                      );
                                                    source.connect(gainNode);
                                                    gainNode.connect(
                                                      audioContext.destination
                                                    );
                                                    // vlog(`Current volume level: ${volumeLevel}`);
                                                    gainNode.gain.value = 0.1;
                                                    audio.play();
                                                  }

                                                  setTimeout(() => {
                                                    wordElement.style.backgroundColor =
                                                      originalBackgroundColor;
                                                  }, 500);
                                                } else if (
                                                  selectedOperation ===
                                                  "word_cloud"
                                                ) {
                                                  if (
                                                    wordElement.classList.contains(
                                                      "double-underline"
                                                    )
                                                  ) {
                                                    wordElement.classList.remove(
                                                      "double-underline"
                                                    );
                                                    vlog(
                                                      "word unselected:"
                                                    );
                                                    vlog(word);
                                                    handleWordCloud(
                                                      word,
                                                      false
                                                    );
                                                  } else {
                                                    wordElement.classList.add(
                                                      "double-underline"
                                                    );
                                                    vlog(
                                                      "word selected:"
                                                    );
                                                    vlog(word);
                                                    handleWordCloud(word, true);
                                                  }
                                                } else if (
                                                  selectedOperation === OPERATION_MODES.EDIT
                                                ) {
                                                  handleStoryEdit(
                                                    storyId,
                                                    sentence.id,
                                                    wordSpanId
                                                  );
                                                } else if (
                                                  selectedOperation === OPERATION_MODES.AUFNEHMEN
                                                ) {
                                                  handleAudioRecording(
                                                    storyId,
                                                    sentence.id
                                                  );
                                                }
                                              }}
                                            >
                                              {sanitizeTtsText(word)}{" "}
                                            </span>
                                          </React.Fragment>
                                        );
                                      })}
                                  
                                </div>
                              </div>
                            )}

                            <div className="character-block-right">
                              {/* Fetch assigned user for this character */}

                              <div className="character-block-assignee">
                                {(() => {
                                  const userToShow = getUserForOperation(
                                    sentence.characterid,
                                    selectedOperation,
                                    currentUser
                                  );

                                  return (                          
                                    currentGroupId !== null && (
                                      <Avatar
                                        className={
                                          userToShow?.userId === currentUser.id
                                            ? "highlight-avatar"
                                            : "normal-avatar"
                                        }
                                        size="small"
                                        // gap={2}
                                        style={{}}
                                      >
                                        {userToShow?.username || "-"}
                                      </Avatar>
                                    )
                                  );
                                })()}

                                <div
                                  style={{
                                    margin: "10px 10px 0px 0px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  {selectedOperation === OPERATION_MODES.GESTALTEN &&
                                    getCurrentUserTaskEntry(
                                      sentence.characterid,
                                      OPERATION_MODES.GESTALTEN
                                    ) && (
                                      <Tooltip
                                        title={
                                          enrichmentsForSentence.length > 0
                                            ? "Gestalten fertig"
                                            : "Gestalten muss gemacht werden"
                                        }
                                      >
                                        <span
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                          }}
                                        >
                                          {enrichmentsForSentence.length > 0 ? (
                                            <CheckCircleOutlined
                                              style={{
                                                color: "white",
                                                backgroundColor: "#7b973d",
                                                borderRadius: "50%",
                                                padding: "0px",
                                                fontSize: "30px",
                                              }}
                                            />
                                          ) : (
                                            <ExclamationCircleOutlined
                                              style={{
                                                color: "white",
                                                backgroundColor: "#E86645",
                                                borderRadius: "50%",
                                                padding: "0px",
                                                fontSize: "30px",
                                              }}
                                            />
                                          )}
                                        </span>
                                      </Tooltip>
                                    )}
                                </div>
                              </div>
                            </div>
                          </main>
                          
                        </li>
                      );
                    })}
                  </ul>
                );
              })}
            </Carousel>
          </ConfigProvider>

          {/* Highlighted Words Drawer */}
          <Drawer
            title={`Markierte Wörter (${highlightedWords.length})`}
            placement="bottom"
            closable={true}
            onClose={() => setDrawerVisible(false)}
            open={drawerVisible}
            height={196}
            mask={false}
            style={{ zIndex: 1001 }}
            className="drawer-sammeln"
            extra={
              <>
              {highlightedWords.length > 0 && (
                  <div style={{ display: "flex", gap: "8px" }}>
                <Button 
                  type="primary" 
                  size="small" 
                  className="entdecken-button"
                  icon={<img src={word_wall_icon} alt="Entdecken" style={{ width: "29px", height: "29px" }} />}
                  onClick={() => {
                    // TODO: Implement entdecken functionality
                    vlog("Entdecken button clicked");
                  }}
                >Entdecken</Button>
                  <Button 
                    type="primary" 
                    danger 
                    size="small" 
                    onClick={clearAllHighlights}
                  >
                    Alle löschen
                  </Button>
                  
              </div>
                )}
              </>
                
            }
          >
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {highlightedWords.map((item, index) => (
                <Tag 
                  key={`${item.wordSpanId}-${index}`}
                  closable
                  closeIcon={<img src={tag_delete_icon} alt="Remove" />}
                  // color={item.color}
                  onClose={(e) => {
                    e.preventDefault();
                    // Remove from highlightedWords
                    setHighlightedWords(prev => prev.filter(wordItem => wordItem.wordSpanId !== item.wordSpanId));
                    
                    // Reset background color of the word in the story
                    const wordElement = document.getElementById(item.wordSpanId);
                    if (wordElement) {
                      // Find the associated character to get the original color
                      const associatedCharacter = selectedCharacters.find(
                        (character) => {
                          // Extract character ID from sentence
                          const sentence = selectedSentences.find(s => s.id === item.sentenceId);
                          return sentence && character.id === sentence.characterid;
                        }
                      );
                      if (associatedCharacter) {
                        wordElement.style.backgroundColor = associatedCharacter.color;
                      }
                    }
                  }}
                >
                  {item.word}
                </Tag>
              ))}
              {highlightedWords.length === 0 && (
                <p>Keine markierten Wörter vorhanden</p>
              )}
            </div>
          </Drawer>

          <Row justify="center" align={"top"}>
            <Pagination
              defaultCurrent={lastPage}
              total={sentences.length}
              current={currentPage}
              pageSize={pageSize}
              pageSizeOptions={[3, 10, 20, 50]}
              onChange={onPageChange}
              showSizeChanger
              //showTotal={(total) => `${total} Seiten`}
              showTotal={() => `Seiten`}
              locale={{
                items_per_page: "/Seiten",
                jump_to: "Gehe zu",
                prev_5: "5 Seiten zurück",
                next_5: "5 Seiten weiter",
                prev_3: "3 Seiten zurück",
                next_3: "3 Seiten weiter",
                prev_page: "Vorherige Seite",
                next_page: "Nächste Seite",
              }}
              // style={{ textAlign: 'center',display: '-webkit-inline-box'}}
            />
          </Row>
          {isLexi && (
            <WordDetective
              isLexi={isLexi}
              setIsLexi={setIsLexi}
              lexiSentence={currentIllusSentence}
            />
          )}
          
          {/* QR Scanner Modal For Auslosen Mode */}
          <Modal
            // title="STREEN QR-Code scannen"
            open={isQrScannerVisible}
            onCancel={() => {
              setIsQrScannerVisible(false);
              setScannerEnabled(false);
              setQrError(null);
            }}
            footer={null}
            className="auslosen-QR-Modal"
            centered
          >
            <Space style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <img src={scan_qr_icon} alt="Scan QR" style={{ width: "32px", height: "32px" }} />
                <span style={{ fontSize: 18 }}>Scanne deinen QR-Code im STREEN-Raum</span>
              </Space>

              {/* Browser compatibility warning */}
              {(typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices) && (
                showMessageWarning(
                  "Kamera nicht unterstützt",
                  "Dein Browser unterstützt die Kamerafunktion nicht. Bitte verwende einen modernen Browser (Chrome, Safari, Firefox) und stelle sicher, dass die Seite über HTTPS geladen wird. Alternativ kannst du den QR-Code manuell eingeben."
                )
              )}
              {scannerEnabled && typeof navigator.mediaDevices !== 'undefined' && navigator.mediaDevices && (
                  <QrReader
                    constraints={{ facingMode: "environment" }}
                    onResult={(result, error) => {
                      if (result?.text) {
                        handleQrResult(result.text);
                        message.info(result.text);
                      }
                      
                      if (error) {
                        vlog("QR Scanner Error:", error);
                        if (error.name === "NotAllowedError") {
                          setQrError("Kamerazugriff verweigert. Bitte erlaube den Kamerazugriff in den Browsereinstellungen.");
                        } else if (error.name === "NotFoundError") {
                          setQrError("Keine Kamera gefunden.");
                        } else if (error.name === "NotReadableError") {
                          setQrError("Kamerafehler. Bitte versuche es erneut.");
                        } else if (error.message && error.message.includes("undefined is not an object")) {
                          setQrError("Kamera nicht unterstützt. Stelle sicher, dass die Seite über HTTPS geladen wird und der Browser aktuell ist.");
                        } else {
                          setQrError("Fehler beim Scannen: " + (error.message || error.toString()));
                        }
                      }
                    }}
                    
                  />
                )}

                {/* Overlay square */}
                <div className="auslosen-mode auslosen-QR-scannen" />

              {qrError && (
                showMessageError(qrError)
              )}


              
              {/* <div style={{ marginTop: 16, textAlign: "center" }}>
                <Button 
                  onClick={() => {
                    // Check browser compatibility
                    if (typeof navigator.mediaDevices === 'undefined' || !navigator.mediaDevices) {
                      setQrError("Kamerafunktion wird von diesem Browser nicht unterstützt.");
                      return;
                    }
                    
                    // Retry scanning
                    setScannerEnabled(false);
                    setQrError(null);
                    setTimeout(() => setScannerEnabled(true), 100);
                  }}
                >
                  Erneut scannen
                </Button>
              </div> */}
          </Modal>
          
        </React.Fragment>
    

        <div className="back-to-top-container">
          <button
            type="button"
            className="back-to-top-button"
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              })
            }
            aria-label="Zurück nach oben"
            title="Nach oben"
          >
            <VerticalAlignTopOutlined className="back-to-top-icon" />
            <span>Nach oben</span>
          </button>
        </div>

    </div>
  );
};

export default ReaderMode;
